export default __webpack_public_path__ + "static/media/Montserrat-Medium.647f0e61.ttf";